// extracted by mini-css-extract-plugin
module.exports = {"surface":"_9Or3F","header":"_2HL+2","body":"GGgYn"};